import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "base-form header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Контрагенты", -1)
const _hoisted_3 = { class: "base-form filter" }
const _hoisted_4 = { class: "base-form filter" }
const _hoisted_5 = { class: "base-form filter" }
const _hoisted_6 = { class: "base-form filter" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_vehicle_filter_component = _resolveComponent("vehicle-filter-component")!
  const _component_counterparty_type_component = _resolveComponent("counterparty-type-component")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          style: {"text-align":"left"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode(_component_el_button, {
                type: "primary",
                icon: _ctx.circleIcon,
                size: "large",
                onClick: _ctx.onAddCounterpartyClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Новый контрагент ")
                ]),
                _: 1
              }, 8, ["icon", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.counterpartySearchFilter,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.counterpartySearchFilter) = $event)),
                placeholder: "Поиск контрагентов по инициалам, телефону, почте",
                clearable: "",
                onClear: _ctx.fetchCounterpartiesAsync,
                onKeyup: _withKeys(_ctx.fetchCounterpartiesAsync, ["enter"]),
                class: "input-with-select"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, { icon: _ctx.searchIcon }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["modelValue", "onClear", "onKeyup"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_vehicle_filter_component, {
                onSelected: _ctx.onVehicleFilterChange,
                placeholder: "Поиск контрагентов по марке, модели, VIN автомобиля"
              }, null, 8, ["onSelected"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_select, {
                multiple: "",
                modelValue: _ctx.counterpartyTypesFilter,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.counterpartyTypesFilter) = $event)),
                placeholder: "Фильтровать контрагентов по типу",
                onChange: _ctx.fetchCounterpartiesAsync
              }, {
                label: _withCtx((scope) => [
                  _createVNode(_component_counterparty_type_component, {
                    type: scope.value
                  }, null, 8, ["type"])
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availCounterpartyTypes, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item,
                      value: item
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_counterparty_type_component, { type: item }, null, 8, ["type"])
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.counterpartyManagersFilter,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.counterpartyManagersFilter) = $event)),
                placeholder: "Фильтровать контрагентов по менеджерам",
                onChange: _ctx.fetchCounterpartiesAsync,
                multiple: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.managers, (m) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: m.id,
                      value: m.id,
                      label: `${m.lastname} ${m.firstname.substring(0,1)}.`
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _ctx.tableData,
              sortable: "custom",
              "default-sort": { prop: _ctx.tableSortColumn, order: _ctx.tableSortOrder },
              onSortChange: _ctx.onTableSortingChange,
              onRowClick: _ctx.onTableRowClick
            }, {
              empty: _withCtx(() => [
                _createVNode(_component_el_text, { type: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Список контрагентов пуст ☹️")
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                (_ctx.isPickerMode)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      width: "100"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: (e) => _ctx.onTablePickCounterpartyClick(scope.row, e)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Выбрать ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_table_column, {
                  label: "Дата регистрации",
                  width: "220",
                  formatter: (r) => _ctx.dateFormatter(r.date),
                  sortable: "",
                  prop: "date"
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "Инициалы",
                  sortable: "",
                  prop: "counterparty"
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.lastname) + " " + _toDisplayString(scope.row.firstname) + " " + _toDisplayString(scope.row.middlename) + " ", 1),
                    (scope.row.legalEntity?.name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_el_text, {
                            type: "info",
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.row.legalEntity.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "Тип контрагента" }, {
                  default: _withCtx((scope) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.types, (t) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: t,
                        style: {"display":"inline-block","margin-right":".3rem"}
                      }, [
                        _createVNode(_component_counterparty_type_component, { type: t }, null, 8, ["type"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "Телефон" }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.phone), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Менеджер",
                  sortable: "",
                  prop: "manager"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.manager?.id)
                      ? (_openBlock(), _createElementBlock("text", _hoisted_8, _toDisplayString(scope.row.manager.lastname) + " " + _toDisplayString(scope.row.manager.firstname ? `${scope.row.manager.firstname.substring(0,1)}.` : ''), 1))
                      : (_openBlock(), _createBlock(_component_el_text, {
                          key: 1,
                          type: "info",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("не назначен")
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "Автомобиль",
                  sortable: "",
                  prop: "vehicle"
                }, {
                  default: _withCtx((scope) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.vehicles, (v) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: v.id,
                        style: {"display":"inline-block","margin-right":".3rem"}
                      }, [
                        _createVNode(_component_el_tag, {
                          size: "small",
                          type: v.ownerChanged ? 'info' : 'primary'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(v?.model.manufacturer?.name) + " " + _toDisplayString(v?.model?.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }),
                (!_ctx.isPickerMode)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 1,
                      align: "right",
                      width: "120"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "danger",
                          onClick: (e) => _ctx.onTableDeleteVehicleClick(scope.row, e)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Удалить ")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["data", "default-sort", "onSortChange", "onRowClick"])), [
              [_directive_loading, _ctx.tableLoading]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}